"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcFixedAssetWorkItemsPanel = class UcFixedAssetWorkItemsPanel extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
        this.$$cache_displayAll = new core_1.ComponentValueCache(this, "displayAll", "FixedAsset.WorkItems.displayAll");
    }
    filterItems(...args) {
        const [items, displayAll, displayCount] = args;
        if (displayAll || displayCount == items.length) {
            return items;
        }
        return _.take(items, displayCount);
    }
    oid;
    onOid(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("oid");
    }
    items;
    async $$load_items() {
        return this.$fn.fetch('list_fixed_asset_works', { parameters: { fixed_asset_id: this.oid } })
            .then(p => _
            .chain(p)
            .orderBy(p, ['date', 'id'], ['asc', 'asc'])
            .groupBy('worksheet_id')
            .map((items, worksheet_id) => ({ ...items[0], items }))
            .value());
    }
    displayAll;
    displayCount;
    ux;
    dataMembers = ['items', 'displayAll', 'displayCount', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                items: null,
                displayAll: false,
                displayCount: 5,
                ux: null,
            },
        };
    }
    get canDisplayMoreItems() {
        if (this.loaded) {
            return !this.displayAll && this.items && this.displayCount < this.items.length;
        }
        return null;
    }
    get canHideItems() {
        if (this.loaded) {
            return this.displayAll && this.items && this.displayCount < this.items.length;
        }
        return null;
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    async act_7736732573189513_setData_6382_getActionArgs($event) {
        return {
            path: "displayAll",
            value: false,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_7736732573189513_clickPreventStop(event, scope) {
        return await this.actions.evh_7736732573189513_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_2912679705172878_setData_6384_getActionArgs($event) {
        return {
            path: "displayAll",
            value: true,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_2912679705172878_clickPreventStop(event, scope) {
        return await this.actions.evh_2912679705172878_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_6380 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_6379 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_6380,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_6379],
        });
        const act_7736732573189513_setData_6382 = new core_1.actions.SetDataAction({
            actionArgs: this.act_7736732573189513_setData_6382_getActionArgs,
            events: [],
        });
        const evh_7736732573189513_clickPreventStop_6381 = new core_1.actions.EventHandlerImpl({
            action: act_7736732573189513_setData_6382,
            event: "click.prevent.stop",
            displayName: "setData",
        });
        const evh_7736732573189513_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7736732573189513_clickPreventStop_6381],
        });
        const act_2912679705172878_setData_6384 = new core_1.actions.SetDataAction({
            actionArgs: this.act_2912679705172878_setData_6384_getActionArgs,
            events: [],
        });
        const evh_2912679705172878_clickPreventStop_6383 = new core_1.actions.EventHandlerImpl({
            action: act_2912679705172878_setData_6384,
            event: "click.prevent.stop",
            displayName: "setData",
        });
        const evh_2912679705172878_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2912679705172878_clickPreventStop_6383],
        });
        return {
            act_7315092382398562_reloadComponentData_6380,
            evh_7315092382398562_reload_6379,
            evh_7315092382398562_reload,
            act_7736732573189513_setData_6382,
            evh_7736732573189513_clickPreventStop_6381,
            evh_7736732573189513_clickPreventStop,
            act_2912679705172878_setData_6384,
            evh_2912679705172878_clickPreventStop_6383,
            evh_2912679705172878_clickPreventStop,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: String,
    }),
    __metadata("design:type", String)
], UcFixedAssetWorkItemsPanel.prototype, "oid", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('oid'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcFixedAssetWorkItemsPanel.prototype, "onOid", null);
UcFixedAssetWorkItemsPanel = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcFixedAssetWorkItemsPanel);
exports.default = UcFixedAssetWorkItemsPanel;
vue_property_decorator_1.Vue.component("UcFixedAssetWorkItemsPanel", UcFixedAssetWorkItemsPanel);
